// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3185":"78db9191c3cfc26c","6690":"9c387aa15c90e2a8","8059":"fe374909c704378d"}[chunkId] + ".css";
};